import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/customer/tenant/customer.tenant.query.gql"
import type {
  CustomerTenantQuery,
  CustomerTenantQueryVariables,
} from "@/v2-backoffice-client/customer/tenant/__types__/customer.tenant.query"

type Options = QueryHookOptions<
  CustomerTenantQuery,
  CustomerTenantQueryVariables
>

export function useCustomerTenantQuery(options?: Options) {
  return useQuery<CustomerTenantQuery, CustomerTenantQueryVariables>(
    query,
    options,
  )
}
